export enum DealStatus {
  Pending = 'pending',
  Active = 'active',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  Awaiting = 'awaiting',
  Suspended = 'suspended',
  NotStarted = 'not_started',
  Completed = 'completed'
}

export const DealsStatusTitles: Record<DealStatus, string> = {
  [DealStatus.Pending]: 'Pending',
  [DealStatus.Active]: 'Active',
  [DealStatus.Awaiting]: 'Waiting for approval',
  [DealStatus.Rejected]: 'Rejected',
  [DealStatus.Cancelled]: 'Cancelled',
  [DealStatus.Suspended]: 'Suspended',
  [DealStatus.NotStarted]: 'Not Started',
  [DealStatus.Completed]: 'Completed'
};

export const getDealsStatusColorMap = (theme: any): Record<DealStatus, string> => ({
  [DealStatus.Pending]: theme.styleguideColors.contentTertiary,
  [DealStatus.Active]: theme.styleguideColors.contentGreen,
  [DealStatus.Awaiting]: theme.styleguideColors.contentYellow,
  [DealStatus.Rejected]: theme.styleguideColors.contentRed,
  [DealStatus.Cancelled]: theme.styleguideColors.contentRed,
  [DealStatus.Suspended]: theme.styleguideColors.contentYellow,
  [DealStatus.NotStarted]: theme.styleguideColors.contentWarmGreen,
  [DealStatus.Completed]: theme.styleguideColors.contentLightBlue
});
